import z from 'zod';
import { $bool } from '../../zod';

export const $deleteAccountRuleParams = z.object({
  programId: z.string().uuid().optional(),
  levelId: z.string().uuid().optional(),
  customKeyTechnicalName: z.string().optional(),
  soft: $bool.optional(),
});

export type DeleteAccountRulesParams = z.infer<typeof $deleteAccountRuleParams>;
